import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import ExpandableImageComponent from '../Image/ExpandableImageComponent';

import { avatarPlaceholderSRC, toSentenceCase } from '../../utils';
import { getFullName } from '../Person/utils';

import { getIsLoading } from '../Shared/selectors';

import usePersonDetails from '../../hooks/usePersonDetails';
import { CallCenterInfoButton } from '../Button';

const getResidentInfo = ({ roles }) => {
  if (!roles?.length) return <div>&nbsp;</div>;
  return (
    <>
      {roles.map(({ roleName, propertyName, personRoleId }) => (
        <Typography key={personRoleId}>
          {`${propertyName} - ${toSentenceCase(roleName)}`}
        </Typography>
      ))}
    </>
  );
};

const GiveAccessComponent = (props) => {
  const {
    id,
    unitName,
    comments,
    onOpenAccessPoint,
    buttonLabel,
    disabledButtonLabel,
    disableIfNoPhoto,
    person = props,
  } = props;

  const isLoading = useSelector((state) => getIsLoading(state));

  const { photo } = usePersonDetails(person);
  const fullName = getFullName(person);
  const residentInfo = getResidentInfo(person);

  const disabled = (disableIfNoPhoto && !photo) || isLoading;
  const label = isLoading
    ? 'Loading...'
    : disabled
    ? disabledButtonLabel
    : buttonLabel;

  return (
    <Box mt="2.5rem" mb="5rem">
      <Box display="flex" mb="6rem">
        <ExpandableImageComponent
          src={avatarPlaceholderSRC}
          photo={photo}
          caption={fullName}
          height="15rem"
          isSquare
        />
        <Box mr="1.5rem" />
        <Box>
          <Typography variant="h5">{fullName}</Typography>
          <Box mr="1.5rem" />
          <Box>{unitName ?? residentInfo}</Box>
          <Box mr="1.5rem" />
          <Box>{comments}</Box>
        </Box>
      </Box>
      <CallCenterInfoButton
        color="primary"
        disabled={disabled}
        onClick={() => onOpenAccessPoint(id)}
      >
        {label}
      </CallCenterInfoButton>
    </Box>
  );
};

GiveAccessComponent.defaultProps = {
  unitName: '',
  comments: '',
  person: undefined,
};

GiveAccessComponent.propTypes = {
  id: PropTypes.number.isRequired,
  onOpenAccessPoint: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  disabledButtonLabel: PropTypes.string,
  disableIfNoPhoto: PropTypes.bool,
  unitName: PropTypes.string,
  comments: PropTypes.string,
  person: PropTypes.instanceOf(Object),
};

export default GiveAccessComponent;
